function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m12.251 13.416h-10.5a1.784 1.784 0 0 1 -1.751-1.816v-1.873a1.785 1.785 0 0 1 1.751-1.818h10.5a1.785 1.785 0 0 1 1.749 1.818v1.873a1.784 1.784 0 0 1 -1.749 1.818zm0-7.324h-10.5a1.786 1.786 0 0 1 -1.751-1.818v-1.874a1.785 1.785 0 0 1 1.751-1.816h10.5a1.785 1.785 0 0 1 1.749 1.816v1.874a1.785 1.785 0 0 1 -1.749 1.818zm0-3.69h-10.5v1.872h10.5v-1.874z",
  fill: "currentColor",
  fillRule: "evenodd"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/goals-filled.e36866d2.svg";
export { SvgComponent as ReactComponent };